import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class ItemCategory
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 * @property {string} color
 * @property {string} code
 */
export class ItemCategory extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'ITEM_CATEGORY_NAME_IN_ENGLISH',
                commonLabel: 'Item Category name'
            },
            name_ar: {
                label: 'ITEM_CATEGORY_NAME_IN_ARABIC',
                commonLabel: 'Item Category name'
            },
            code: {
                label: 'CATEGORY_CODE',
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...ItemCategory.translatableAttributesWithLanguageAliases, 'property', 'color', 'code', 'items')(ItemCategory);


// WEBPACK FOOTER //
// ./src/pms-api/models/item-category.model.js